import { render, staticRenderFns } from "./LLMcard.vue?vue&type=template&id=b6753604&"
import script from "./LLMcard.vue?vue&type=script&lang=js&"
export * from "./LLMcard.vue?vue&type=script&lang=js&"
import style0 from "./LLMcard.vue?vue&type=style&index=0&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports